import { render, staticRenderFns } from "./OrderGroup.vue?vue&type=template&id=b50f3242&scoped=true&"
import script from "./OrderGroup.vue?vue&type=script&lang=ts&"
export * from "./OrderGroup.vue?vue&type=script&lang=ts&"
import style0 from "./OrderGroup.vue?vue&type=style&index=0&id=b50f3242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50f3242",
  null
  
)

export default component.exports